import { getAbortSignal, handleFetchWithAbortException } from 'utils/abortSignal'
import { WhammyApiError } from 'utils/WhammyApiError'

export type IntelligentAskAmountResponse = {
  error?: { [key: string]: string[] }
  grid: {
    suggested_donation_amount: number[] | null
    suggested_recurring_amount: number[] | null
  }
  // Force recurring frequency
  is_default_recurring: boolean | null
  // Whether the Donation block should show a nudge on the recurring frequency button
  show_recurring_upsell: boolean | null
  // One-time "other" amount
  suggested_donation_amount: number | null
  // Recurring "other" amount
  suggested_recurring_amount: number | null
}

export const getIntelligentAskAmount = async (
  campaignId: string,
  isPreviewPage = false,
): Promise<IntelligentAskAmountResponse> => {
  const screenHeight = window?.screen?.height || 0
  const screenWidth = window?.screen?.width || 0

  try {
    const response = await fetch('/api/intelligentAskAmount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // Abort the fetch if it takes longer than 1 second
      signal: getAbortSignal(1000),
      body: JSON.stringify({
        campaignId,
        screenHeight,
        screenWidth,
        isPreviewPage,
      }),
    })

    const intelligentAskAmountResponse: IntelligentAskAmountResponse = await response.json()

    if (response.status >= 400) {
      throw WhammyApiError({
        message: JSON.stringify(intelligentAskAmountResponse.error),
        statusCode: response.status,
      })
    }

    // The grid property can possibly be null
    if (intelligentAskAmountResponse.grid === null) {
      intelligentAskAmountResponse.grid = {
        suggested_donation_amount: null,
        suggested_recurring_amount: null,
      }
    }

    return intelligentAskAmountResponse
  } catch (e) {
    handleFetchWithAbortException(
      e as Error,
      `Unable to fetch Intelligent Ask Amount for ${campaignId}`,
    )
    return {
      grid: {
        suggested_donation_amount: null,
        suggested_recurring_amount: null,
      },
      is_default_recurring: null,
      show_recurring_upsell: null,
      suggested_donation_amount: null,
      suggested_recurring_amount: null,
    }
  }
}
